<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="characters-in-the-story-in-the-order-of-appearance">
<h1>Characters in the Story in the<br/> Order of Appearance</h1>
<p><strong>Dao –</strong> Thai female, Bussaba’s and Arun’s daughter, a senior student</p><br/>
<p style="text-indent:0em"><strong>Yai</strong> – Thai male, Dao’s boyfriend, a senior student</p><br/>
<p style="text-indent:0em"><strong>Ying –</strong> Dao’s classmate and friend</p><br/>
<p style="text-indent:0em">Teacher <strong>Bundit</strong> – middle-aged Thai male, crewcut hair, jovial, practical, authoritative, slightly overweight; has relative working in an important position in the Tourist Association of Thailand</p><br/>
<p style="text-indent:0em">Teacher <strong>Mali</strong> – Thai female with long hair tied back, grave character, kind, multilingual, teaches mathematics</p><br/>
<p style="text-indent:0em"><strong>Warun</strong> – Thai male, waterworks official</p><br/>
<p style="text-indent:0em"><strong>Bussaba</strong> – Thai female, owner of the restaurant and grocery shop</p><br/>
<p style="text-indent:0em"><strong>Boriphoon</strong> – Thai male graduating student at the teacher’s college, a middle-built, well-groomed city boy from the capitol city of Bangkok</p><br/>
<p style="text-indent:0em"><strong>Chai</strong> – Thai male, Boriphoon’s classmate, well-tanned, son of a local fruit farmer, light built, handsome, very adept at agricultural skills</p><br/>
<p style="text-indent:0em"><strong>Achara</strong> – daughter of the Lisu hill tribe village chief in western central Thailand, now performing at the light and sound show; also working part-time at the nearby shop Bussaba’s</p><br/>
<p style="text-indent:0em">Teacher <strong>Parin</strong> – tall Thai female, teaches biology, social sciences, and history</p><br/>
<p style="text-indent:0em"><strong>Lek</strong> – Thai male, fourth-generation Portuguese background, prominent nose, PTA leader</p><br/>
<p style="text-indent:0em"><strong>Nin</strong> – Thai female, third generation Indian background, PTA leader</p><br/>
<p style="text-indent:0em"><strong>Ananda</strong> – Thai male, local police officer, municipality officer, police chief</p><br/>
<p style="text-indent:0em"><strong>Saengdao</strong> – Thai female, sells fruit at the local market and at the sound and light show, mother of Chai, wife of Kiat</p><br/>
<p style="text-indent:0em">Teacher <strong>Chariya</strong> – small Thai lady, teaches music, the local Rotary club leader; make-up stylist for the light and sound show</p>
<p style="text-indent:0em"><strong>Kasem</strong> – Thai male chief of subdistrict</p><br/>
<p style="text-indent:0em"><strong>Hom</strong> – female, wife of Kasem, panellist in the dance contest in the light and sound show</p><br/>
<p style="text-indent:0em"><strong>Chantana</strong> – male relative of Chai, an electric store owner</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?38fce6c7